import UpcomingAuctions from "./UpcomingAuctions";

export default UpcomingAuctions;
